module.exports = __webpack_public_path__ + "static/img/14.bbe0c8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/14.jpg
// module id = H68k
// module chunks = 1